import React, { useLayoutEffect, useState, useEffect } from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";

import Modal from "react-modal";
import Swal from "sweetalert2";
import { TextBox, CheckBox } from "devextreme-react";
import { useNavigate } from "react-router-dom";
import { AssetStatusService } from "../../../apis/apiServices/AssetStatus";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@iconify/react";

export default function AssetStatusComponent() {
  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = "Status Type";
    getAssetStatusList();
  }, []);

  const user = useSelector((state) => state.user.data);
  const navigate = useNavigate();
  const [isCityModalOpen, setIsCityModalOpen] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [AssetStatusList, setAssetStatusList] = useState([]);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const closeViewModal = () => {
    setIsModalOpen(false);
  };


  const [AssetStatus, SetOwnership] = useState({
    id: 0,
    name: "",
    code: "",
    isActive: true,
  });

  const getAssetStatusList = async () => {
    try {
      const response = await AssetStatusService.getAssetStatus();
      setAssetStatusList(response?.data);
    } catch (error) { }
  };

  useEffect(() => {
    getAssetStatusList();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);

    const newErrors = {};
    if (!AssetStatus.name) newErrors.name = "Please enter status type name";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      setIsSubmitted(false);
      return;
    }


    try {
      let body = {
        id: AssetStatus.id,
        name: AssetStatus?.name || "",
        code: AssetStatus?.code || "",
        isActive: AssetStatus?.isActive || false,
        ModifiedBy: 0,
      };

      const response = await AssetStatusService.addAssetStatus(body);

      if (!response?.isSuccess) {
        Swal.fire("Error!", `${response?.message}`, "error");
        setIsSubmitted(false);
        setErrors(response?.errors || {});
        return;
      }

      getAssetStatusList();
      setIsSubmitted(false);

      Swal.fire("Success!", `${response?.message}`, "success").then(() => {
        navigate(("/AssetStatus", { replace: true }));
        closeModal();

      });

    } catch (error) {
      console.log(error);
    }
  };

  const openModal = () => {
    setIsCityModalOpen(true);
  };

  const closeModal = () => {
    setIsCityModalOpen(false);
    setIsSubmitted(false);
    setErrors({});
    SetOwnership({
      id: 0,
      name: "",
      code: "",
      isActive: true,
    });
  };

  const handleInputChange = (e, field) => {
    SetOwnership((prev) => ({
      ...prev,
      [field]: e.value,
    }));
  };

  const renderStatusCell = ({ value }) => {
    const isActive = value === true;

    return (
      <div
      // style={{
      //     display: 'inline-flex',
      //     alignItems: 'center',
      //     padding: '0px 11px',
      //     borderRadius: '9999px',
      //     fontWeight: 500,
      //     color: isActive ? '#15803d' : '#dc2626',
      //     backgroundColor: isActive ? '#dcfce7' : '#fee2e2',
      //     fontSize: '14px',
      //     width: 'fit-content'
      // }}
      >
        <span />
        {isActive ? "Active" : "Inactive"}
      </div>
    );
  };
  const handleRowClick = (e) => {
    SetOwnership({
      id: e.data.id,
      name: e.data.name,
      code: e.data.code,
      isActive: e.data.isActive,
    });
  };
  const handledelete = (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Delete",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Deleted", "", "success");
      } else if (result.isDenied) {
        Swal.fire("Changes are not saved", "", "info");
      }
    });
  };
  const onCellPrepared = (e) => {
    if (e.rowType === "header") {
      e.cellElement.style.backgroundColor = "#595959"; // #808080
      e.cellElement.style.color = "White";
    } else {
      e.cellElement.style.color = "#353839";
    }
  };
  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              dataSource={AssetStatusList}
              // columnAutoWidth={true}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              onRowClick={(e) => handleRowClick(e)}
              allowColumnResizing={false}
              allowColumnReordering={true}
              // onCellPrepared={onCellPrepared}
              width={"100%"}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  {
                    location: "before",
                    widget: "dxButton",
                    options: {
                      icon: "plus",
                      text: "Add",
                      hint: "Add",
                      type: "default",
                      stylingMode: "contained",
                      onClick: () => openModal(),
                    },
                  },
                  {
                    location: "before",
                    widget: "dxButton",
                    options: {
                      icon: "refresh",
                      text: "Refresh",
                      hint: "Refresh",
                      type: "default",
                      stylingMode: "outlined",
                      onClick: () => getAssetStatusList(),
                    },
                  }
                );
              }}
            >
              <HeaderFilter visible={false} />
              <Column
                width="60px"
                caption={""}
                alignment={"center"}
                cellRender={(cellData) => {
                  return (
                    <span>
                      {/* <Icon
                            className="iconify-size mr-2"
                            title="View"
                            tooltip="View"
                            icon="solar:document-text-outline"
                            style={{ cursor: "pointer" }}
                            onClick={() => setIsModalOpen(true)}
                          /> */}

                      <Icon
                        className="iconify-size mr-2"
                        title="Edit"
                        tooltip="Edit"
                        icon="solar:pen-line-duotone"
                        style={{ cursor: "pointer" }}
                        onClick={() => setIsCityModalOpen(true)}
                      />

                      <Icon
                        className="iconify-size"
                        title="Delete"
                        tooltip="Delete"
                        icon="fluent:delete-32-regular"
                        style={{ cursor: "pointer" }}
                        onClick={(e) => handledelete(e)}
                      />
                    </span>
                  );
                }}
              ></Column>

              
              <Column
                width="200px"
                dataField="name"
                caption="Name"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                width="100px"
                dataField="code"
                caption="Code"
                allowFiltering={false}
                allowSearch={true}
              />
              <Column
                width="100px"
                dataField="isActive"
                caption="Status"
                cellRender={renderStatusCell}
                alignment="left"
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={15} />
              <Pager displayMode="compact" showInfo={true} visible={true} />

              <Export enabled={false} fileName="Vendors" />
            </DataGrid>
          </div>
        </div>
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={isCityModalOpen}
        className="react-modal custom-modal-small"
        onRequestClose={closeModal}
        shouldCloseOnOverlayClick={false}
        contentLabel="Ownership Type Modal"
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">Add/Edit Asset Status</div>
          </div>

          <div className="modal-body">
            
              
                
             
             
                <div className="form-group">
                  <label>                  
                    Name <span className="text-danger">*</span>
                  </label>
                  <TextBox
                    className={`form-control ${errors.name ? "is-invalid" : ""
                      }`}
                    placeholder="Enter status type name"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={AssetStatus.name}
                    onValueChanged={(e) => handleInputChange(e, "name")}
                  />
                  {errors.name && (
                    <div className="error invalid-feedback">{errors.name}</div>
                  )}
                </div>
                <div className="form-group">
                  <label>Code </label>
                  <TextBox
                    className={`form-control ${errors.code ? "is-invalid" : ""
                      }`}
                    placeholder="Enter code"
                    showClearButton={true}
                    valueChangeEvent="keyup"
                    value={AssetStatus.code}
                    onValueChanged={(e) => handleInputChange(e, "code")}
                  />
                  {errors.code && (
                    <div className="error invalid-feedback">{errors.code}</div>
                  )}
                </div>
             
              {/*<div className="col-lg-6 col-md-6 col-sm-12">
                <div className="form-group">
                                <label>Description </label>
                                <TextBox
                                    className={`form-control ${errors.description ? 'is-invalid' : ''}`}
                                    placeholder="Enter Description"
                                    showClearButton={true}
                                    valueChangeEvent="keyup"
                                    value={Ownership.description}
                                    onValueChanged={(e) => handleInputChange(e, "description")}
                                />
                                {errors.description && (
                                    <div className="error invalid-feedback">{errors.description}</div>
                                )}
                            </div> 
              </div>*/}
              <div className="form-group">
                <CheckBox
                  text="Is Active"
                  value={AssetStatus.isActive}
                  onValueChanged={(e) => handleInputChange(e, "isActive")}
                />
              </div>
           
          </div>

          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeModal}
              title="Cancel"
            >
              <i className="fas fa-times"></i> Cancel
            </button>
            <button type="submit" className="btn btn-primary btn-sm">
              {isSubmitted ? (
                <span title="In process">
                  <i className="fas fa-spinner fa-spin"></i> In process
                </span>
              ) : (
                <span title="Submit"> <i className="fas fa-check"></i> Submit</span>
              )}
            </button>
          </div>
        </form>
      </Modal>
      <Modal
        ariaHideApp={false}
        isOpen={isModalOpen}
        className="react-modal resmodel"
        onRequestClose={closeViewModal}
      >
        <form
          onSubmit={handleSubmit}
          style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}
        >
          <div className="modal-header">
            <div className="modal-title">View Status Type</div>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-lg-12">
                <div className="form-group">
                  <p><span className="labelview">Code: </span> <span className="formtextstyle">{AssetStatus.code}</span></p>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="form-group">
                  <p><span className="labelview">Name: </span> <span className="formtextstyle">{AssetStatus.name}</span></p>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                <div className="form-group">
                  <p><span className="labelview">Status: </span> <span className="formtextstyle">{AssetStatus.isActive ? "Active" : "Inactive"}</span></p>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-outline-primary btn-sm"
              onClick={closeViewModal}
              title="Cancel"
            ><i className="fas fa-times"></i> Close </button>
          </div>
        </form>
      </Modal>
    </>
  );
}
